export default __webpack_public_path__ + "static/media/Levitate D6.2 Short-term Impacts of CCAM on Passenger Transport.5a874cc2.pdf";